import { render, staticRenderFns } from "./dialog-following.vue?vue&type=template&id=1a30d862&scoped=true&"
import script from "./dialog-following.vue?vue&type=script&lang=js&"
export * from "./dialog-following.vue?vue&type=script&lang=js&"
import style0 from "./dialog-following.vue?vue&type=style&index=0&id=1a30d862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a30d862",
  null
  
)

export default component.exports